/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Aria_LabelInputs */

const en_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge selected events`)
};

const fr_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner les evenements selectionnes`)
};

const de_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse zusammenführen`)
};

const it_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci gli eventi selezionati`)
};

const ru_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединить выбранные события`)
};

const es_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar eventos seleccionados`)
};

const zh_cn2_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并选定事件`)
};

const ja_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを結合する`)
};

const hi_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं को मर्ज करें`)
};

const pt_pt2_merge_aria_label = /** @type {(inputs: Merge_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Merge selected events" |
*
* @param {Merge_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_aria_label = /** @type {((inputs?: Merge_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_aria_label(inputs)
	if (locale === "de") return de_merge_aria_label(inputs)
	if (locale === "it") return it_merge_aria_label(inputs)
	if (locale === "ru") return ru_merge_aria_label(inputs)
	if (locale === "es") return es_merge_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_aria_label(inputs)
	if (locale === "ja") return ja_merge_aria_label(inputs)
	if (locale === "hi") return hi_merge_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_aria_label(inputs)
	return en_merge_aria_label(inputs)
});